import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Col, Row, Table } from 'reactstrap';
import getShippingLineLinkUrl from 'helpers/shipping_line_url';
import countryFlag from 'common/countryFlag';
import { taskBadges } from 'constants/layout';
import moment from 'moment';

const PendingAndOtherTask = props => {
	const [open, setOpen] = useState('');

	const toggle = id => {
		if (open === id) {
			setOpen();
		} else {
			setOpen(id);
		}
	};
	return (
		<Accordion key={props.index} open={open} toggle={toggle}>
			<AccordionItem key={props.item.bookingNumber}>
				<AccordionHeader targetId={props.item.bookingNumber}>
					<Row className="w-100">
						<Col md="4">
							<h4 className="card-title font-size-12">
								{props.index + 1}. {props.item.bookingNumber} ({props.item?.tasksDetails[0]?.length})
							</h4>
							<span className="ms-2">
								<i className="fas fa-boxes" style={{ marginRight: '2px' }} />(
								{props.item?.bookingDetails?.bookingContainer})
							</span>
						</Col>
						<Col md="8">
							<div className="font-size-11">
								{props.item?.bookingDetails?.loadingLocation != '' ? (
									<>
										{props.item?.bookingDetails?.loadingLocation}
										<i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle " />
									</>
								) : null}
								{props.item?.bookingDetails?.polLocation}{' '}
								{countryFlag[props.item?.bookingDetails?.polCountry.toLowerCase()]}
								<i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle " />
								{props.item?.bookingDetails?.podLocation}{' '}
								{countryFlag[props.item?.bookingDetails?.podCountry.toLowerCase()]}
							</div>
							<div className="mt-2 font-size-11">
								<span>Customer : {props.item?.bookingDetails?.bookingCustomer}</span>
								<span className="ms-2">| </span>
								<span>
									Freight Carriers :
									{props.item?.bookingDetails?.bookingLine != '' ? (
										<>{getShippingLineLinkUrl(props.item?.bookingDetails?.bookingLine, props.item.bookingNumber)}</>
									) : null}
								</span>
							</div>
						</Col>
					</Row>
				</AccordionHeader>
				<AccordionBody accordionId={props.item.bookingNumber}>
					<Row>
						<Table className="table table-centered table-nowrap">
							<thead>
								<tr>
									<th>Task No.</th>
									<th>Task Name</th>
									<th>Task Type</th>
									<th>Task Date</th>
									<th>Status</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								{props.item?.tasksDetails?.length > 0 ? (
									props.item?.tasksDetails[0].map((taskitem, index) => (
										<tr key={index}>
											<td>{index + 1}</td>
											<td>{taskitem.name}</td>
											<td>{taskitem.taskType}</td>
											<td>
												{taskitem.startDate === taskitem.dueDate
													? moment(taskitem.startDate).format('DD-MM-YYYY')
													: moment(taskitem.startDate).format('DD-MM-YYYY') +
													  ' - ' +
													  moment(taskitem.dueDate).format('DD-MM-YYYY')}
											</td>
											<td>
												<span
													className={`badge badge-sm ms-2  ${
														{
															...taskBadges
														}[taskitem?.currentStatusValue]
													}`}
												>
													{taskitem?.currentStatusValue}
												</span>
											</td>
											<td>
												<Link to={`/booking-details/${props.item.bookingNumber}`} className="btn btn-primary btn-sm">
													View
												</Link>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td colSpan="6" className="text-center">
											No Task Found
										</td>
									</tr>
								)}
							</tbody>
						</Table>
					</Row>
				</AccordionBody>
			</AccordionItem>
		</Accordion>
	);
};

export default PendingAndOtherTask;
